'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:HolydayService
 * @description
 * # HolydayService
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('Holyday', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_HOLYDAY_URL = domain.name + '/api/v1/holydays/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_HOLYDAY_URL,
      baseModelName: 'holyday'
    });

    baseService.downloadHolydaysFormat = function() {
      return $http.get(domain.name + '/api/v1/holydays/download_holydays_format');
    };

    baseService.importHolydays = function(file) {
      $http.defaults.headers.put = {"content-type": undefined };
      return $http.put(domain.name + '/api/v1/holydays/import_holydays', file);
    };

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    return baseService;
  }]);
